fragment StaffTrainingPolicyFields on StaffTrainingPolicy {
  id
  title
  version
  url
  acknowledgedAt
  dueOn
  overdue
}
